/** Labels alineados a nomenclatura Kubernetes (Condition / Deployment status). */
export function k8sStatusLabel(status) {
  switch (status) {
    case 'ok':
      return 'Ready'
    case 'warn':
      return 'NotReady'
    case 'error':
      return 'Unavailable'
    case 'unknown':
    default:
      return 'Unknown'
  }
}
